export class Login {
  static readonly type = '[User] Login]';
  constructor(public readonly credentials: { email: any; password: any }) { }
}

export class SignOut {
  static readonly type = '[User] SignOut]';
  constructor() { }
}

export class UpdateUserSession {
  static readonly type = '[User] UpdateUserSession]';
  constructor(public readonly info: {
    firebaseUser: any,
    token: string | null,
    isGhost: string,
  }) { }
}

export class WatchIdToken {
  static readonly type = '[User] WatchIdToken]';
}

export class ResetPasswordEmail {
  static readonly type = '[User] ResetPasswordEmail]';
  constructor(public readonly email: string) { }
}

export class SetDarkModePreference {
  static readonly type = '[User] SetDarkModePreference]';
  constructor(public readonly darkMode: boolean) { }
}
